import styled from 'styled-components';

export const CareersWrapper = styled.div`
  position: relative;
  z-index: 2;
`;
